import React, { FunctionComponent } from "react";
import { $$ } from "../helpers";
import { FormattedMessage } from "react-intl-phraseapp";

const MonthlyPlanPremiumDisclaimer: FunctionComponent<{
  premium: number;
  className?: string;
}> = ({ premium, className }) => {
  return (
    <p className={`ds-u-font-style--italic ${className}`}>
      <FormattedMessage
        id="monthly_premium_disclaimer"
        values={{ premium: $$(premium) }}
      />
    </p>
  );
};

export default MonthlyPlanPremiumDisclaimer;
